/*
* 应用权限设置和文件管理模块
* 提供打开系统设置页面和文件管理器的功能
* */
import load from "@/common/load";
import {getRecordPath} from './monitor'

/* 全局变量声明 - 用于Android系统交互 */
let main, /* Android主Activity实例 */
    pkName, /* 应用包名 */
    Settings, /* Android设置类 */
    Uri, /* Android URI类 */
    Intent, /* Android意图类 */
    loaded; /* 标记是否已初始化 */


/**
 * 打开系统文件管理器并定位到录音文件目录
 * 允许用户直接在文件管理器中查看和管理录音文件
 */
function dir() {

    /* 获取当前设备的录音文件存储目录 */
    const path = getRecordPath();

    /* 初始化Android相关类（避免重复初始化） */
    if (!loaded) {
        /* 获取当前应用的主Activity */
        main = plus.android.runtimeMainActivity();
        /* 导入Android Intent类 */
        Intent = plus.android.importClass('android.content.Intent')
        /* 导入Android URI类 */
        Uri = plus.android.importClass("android.net.Uri");
        /* 标记已初始化 */
        loaded = true;
    }

    /* 构建指向录音目录的URI，将路径中的斜杠转换为URL编码 */
    let uri = Uri.parse("content://com.android.externalstorage.documents/document/primary:" + path.replace(/\//g, '%2f'));
    /* 创建打开文档的Intent */
    let intent = new Intent(Intent.ACTION_OPEN_DOCUMENT);

    /* 添加可打开类别，表示只显示可以打开的文件 */
    intent.addCategory(Intent.CATEGORY_OPENABLE);
    /* 设置文件类型过滤器，表示显示所有类型的文件 */
    intent.setType("*/*");
    /* 设置初始URI，让文件管理器直接定位到录音目录 */
    intent.putExtra('android.provider.extra.INITIAL_URI', uri);
    /* 启动文件管理器Activity */
    main.startActivityForResult(intent, 0);

}

/**
 * 打开当前应用的系统设置页面
 * 用户可以在此页面管理应用的各种权限设置
 * 包括存储权限、电话权限、悬浮窗权限等
 */
function set() {

    /* 初始化Android相关类（避免重复初始化） */
    if (!loaded) {
        /* 获取当前应用的主Activity */
        main = plus.android.runtimeMainActivity();
        /* 获取当前应用的包名 */
        pkName = main.getPackageName();
        /* 导入Android设置类 */
        Settings = plus.android.importClass('android.provider.Settings');
        /* 导入Android URI类 */
        Uri = plus.android.importClass('android.net.Uri');
        /* 导入Android Intent类 */
        Intent = plus.android.importClass('android.content.Intent');
        /* 标记已初始化 */
        loaded = true;
    }

    /* 创建跳转到应用详情设置页面的Intent */
    let intent = new Intent(
        Settings.ACTION_APPLICATION_DETAILS_SETTINGS, /* 应用详情设置动作 */
        Uri.parse('package:' + pkName) /* 指定当前应用的包名 */
    )

    try {
        /* 启动应用设置页面 */
        main.startActivity(intent);
    } catch (e) {
        /* 捕获异常并显示错误信息 */
        load.toast(JSON.stringify(e))
    }

}


export default {
    dir,
    set
}